import isCompanyField from './isCompanyField';
import isTicketField from './isTicketField';
const getShouldUseOldIdentifer = field => isCompanyField(field) || isTicketField(field);
const getIdentifier = field => {
  if (getShouldUseOldIdentifer(field)) {
    return `${field.propertyObjectType}-${field.name}`;
  }
  return `${field.objectTypeId}-${field.name}`;
};
export default getIdentifier;